// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"Badge_screenReaderText__23KdE","badge":"Badge_badge__3px7Q"};